<template>
  <div class="app_scenarios-container">
    <div class="title">应用场景</div>
    <div class="app-box">
      <div class="app-center">
        <router-link
          v-for="(item, index) in list"
          :key="index"
          :class="'ball ba' + (index + 1)"
          :to="'/data_public/index?dataCategoryId=' + item.id"
        >
          <div :class="'ball-border' + (index + 1)"></div>
          <img :src="item.logoUrl" alt="" />
          {{ item.name }}
        </router-link>

        <div class="app-icon">
          <img src="@/assets/icon_png.png" alt="" />
        </div>

        <div class="reball1"></div>

        <div class="reball2"></div>

        <div class="reball3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppMarkHot } from "@/api/index";
export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      var { result } = await getAppMarkHot({ isHeader: 1 });
      this.list = result;
    },
    onSubmit() {
      console.log("submit!");
    },
    reset() {
      this.form = {
        name: "",
        type: "",
        mobile: "",
        email: "",
        content: "",
        title: ""
      };
      this.$refs["form"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.app_scenarios-container {
  margin: 0 auto;
  padding-bottom: 40px;
  padding-top: 30px;
  background: #fff;
  .app-box {
    height: 710px;
    // background-size: cover;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .app-center {
      z-index: 100;
      .app-icon {
        position: absolute;
      }
      .reball1 {
        background: url("~@/assets/b6-3faea9744eefb84c3b2e43f93dc982de.png");
        width: 18px;
        height: 18px;
        top: 140px;
        left: 100px;
        animation: b1 linear infinite 4s;
        background-size: 100% 100%;
        animation-delay: 2s;
        position: absolute;
      }

      .reball2 {
        position: absolute;
        background: url("~@/assets/b5-630be78290b663c6cecd996c07603bed.png");
        background-size: 100% 100%;
        width: 18px;
        height: 18px;
        right: 160px;
        bottom: 100px;
        animation: b2 linear infinite 4s;
        animation-delay: 2s;
      }

      .reball3 {
        position: absolute;
        background: url("~@/assets/b4-a4b8d276537eef8e1737eb99fcd271f0.png");
        background-size: 100% 100%;
        width: 18px;
        height: 18px;
        right: 280px;
        top: 100px;
        animation: b3 linear infinite 4s;
        animation-delay: 2s;
      }

      @keyframes b1 {
        0%,
        100%,
        50% {
          top: 140px;
        }

        25% {
          top: 170px;
        }

        75% {
          top: 150px;
        }
      }

      @keyframes b3 {
        0%,
        100%,
        50% {
          top: 100px;
        }

        25% {
          top: 120px;
        }

        75% {
          top: 130px;
        }
      }

      @keyframes b2 {
        0%,
        100%,
        50% {
          bottom: 100px;
        }

        25% {
          bottom: 120px;
        }

        75% {
          bottom: 130px;
        }
      }

      .ball {
        position: relative;
        width: 120px;
        height: 120px;
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(224, 227, 231, 0.73);
        border: 1px solid #eeedf2;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;

        img {
          margin-bottom: 16px;
          width: 50px;
          height: 34px;
          object-fit: scale-down;
        }
      }
      .ball:hover {
        content: "";
        background: #a9e3ff !important;
      }
      .ball-border1,
      .ball-border2,
      .ball-border3,
      .ball-border4,
      .ball-border5,
      .ball-border6,
      .ball-border7,
      .ball-border8 {
        position: absolute;
        width: 0;
        height: 0;
        background: url("~@/assets/circle-border.png");
        background-size: 100% 100%;
        animation: turn 10s linear infinite;
      }

      @keyframes turn {
        0% {
          -webkit-transform: rotate(0deg);
        }
        25% {
          -webkit-transform: rotate(90deg);
        }
        50% {
          -webkit-transform: rotate(180deg);
        }
        75% {
          -webkit-transform: rotate(270deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
        }
      }

      .ba1:hover .ball-border1 {
        width: 138px;
        height: 138px;
      }
      .ba2:hover .ball-border2 {
        width: 138px;
        height: 138px;
      }
      .ba3:hover .ball-border3 {
        width: 138px;
        height: 138px;
      }
      .ba4:hover .ball-border4 {
        width: 138px;
        height: 138px;
      }
      .ba5:hover .ball-border5 {
        width: 138px;
        height: 138px;
      }
      .ba6:hover .ball-border6 {
        width: 138px;
        height: 138px;
      }
      .ba7:hover .ball-border7 {
        width: 138px;
        height: 138px;
      }

      .ball:nth-child(1) {
        position: absolute;
        top: -60px;
      }

      .ball:nth-child(2) {
        position: absolute;
        top: 80px;
        left: 120px;
      }

      .ball:nth-child(3) {
        position: absolute;
        bottom: 120px;
        left: 50px;
      }
      .ball:nth-child(4) {
        position: absolute;
        bottom: -10px;
        left: 240px;
      }
      .ball:nth-child(5) {
        position: absolute;
        bottom: -10px;
        right: 180px;
      }
      .ball:nth-child(6) {
        position: absolute;
        bottom: 120px;
        right: 50px;
      }
      .ball:nth-child(7) {
        position: absolute;
        top: 50px;
        right: 100px;
      }
      background: url("~@/assets/ellipse.png");
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 1100px;
      height: 530px;
    }
  }
  .app-box::after {
    position: absolute;
    width: 100%;
    height: 100%;
    content: "";
    opacity: 0.3;
    background: url("~@/assets/app_bg.png") no-repeat;
    z-index: 1;
  }
  .title {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    line-height: 33px;
    margin-bottom: 40px;
    text-align: center;
  }
}
</style>
